class DreambabyCustomerMailHandler {
  constructor({ endpointUrl, proxyToken }) {
    this.endpointUrl = endpointUrl || '';
    this.proxyToken = proxyToken || '';
  }

  async triggerActivateAccount(customerEmail) {
    if ('' === this.endpointUrl || '' === this.proxyToken) {
      console.error('[CustomerMailHandler] Endpoint URL or proxy token not provided.');
    }

    if (!customerEmail || !customerEmail.trim()) {
      console.error('[CustomerMailHandler] No email provided.');
      return false;
    }

    try {
      const response = await fetch(this.endpointUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.proxyToken}`
        },
        body: JSON.stringify({ customerEmail }),
        keepalive: true
      });

      if (response.ok) {
        console.log(`[CustomerMailHandler Activate account] Trying to send activation email to ${customerEmail}`);
        return true;
      }

      console.error('[CustomerMailHandler Activate account] Proxy call failed:', response.status, response.statusText);
      return false;
    } catch (error) {
      console.error('[CustomerMailHandler Activate account] Error during proxy call:', error.message, error);
      return false;
    }
  }

  async triggerResetPassword(customerEmail) {
    if (!customerEmail || !customerEmail.trim()) {
      console.error('[CustomerMailHandler Reset password] No email provided.');
      return false;
    }

    const recoverUrl = '/account/recover';
    const formData = new URLSearchParams();
    formData.append('form_type', 'recover_customer_password');
    formData.append('email', customerEmail);

    try {
      const response = await fetch(recoverUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
        keepalive: true
      });

      if (response.ok) {
        console.log(`[CustomerMailHandler Reset password] Password recovery request submitted for ${customerEmail}. Shopify will handle sending the email.`);
        return true;
      }
      console.error(`[CustomerMailHandler Reset password] Failed to submit password recovery request for ${customerEmail}. Status: ${response.status}`);
      return false;
    } catch (error) {
      console.error('[CustomerMailHandler Reset password] Error submitting password recovery request:', error);
      return false;
    }
  }
}

window.DreambabyCustomerMailHandler = DreambabyCustomerMailHandler;